import React from "react";
import webConfig from "../../web.config.map";

export const Urls = webConfig.Urls;
export const microserviceNames = webConfig.microserviceNames;




export const Grades = {
  NEW: "E",
  D: "D",
  C: "C",
  B: "B",
  A: "A",
};

export const GradeApplicationStatus = {
  NEW: "new",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EDITED: "edited",
  DRAFT: "draft",
  RENEWAL: "renewal",
};

export const FILE_SIZE = 5000000;

export const SUPPORTED_FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  ".xlx",
  ".doc",
  ".docx",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const SUPPORTED_PHOTO_TYPES = ["image/png", "image/jpeg", "image/jpg"];

export const HtmlInputTypes = {
  TRANSLATABLE: "translatable",
  TEXT: "text",
  LINK: "link",
  TEXTAREA: "textarea",
  LOCATION: "location",
  NUMBER: "number",
  EMAIL: "email",
  PHONE: "phone",
  SELECT: "select",
  MULTISELECT: "multi-select",
  DATE: "date",
  RATING: "rating",
  FILE: "file",
  FILES: "files",
  TOGGLE: "toggle",
  SLIDER: "slider",
  RANGE: "range",
  TIME_RANGE: "time-range",
  COUNTRY_FLAGS: "country-flags",
  FACILITY_GROUP: "facility-group",
  NESTED_QUESTION: "nested-question",
  MULTISELECT_FILES: 'multi-select-files',
  TABLE: 'table'
};

export const ValidationTypes = {
  STRING: "string",
  NUMBER: "number",
  FILE: "file",
  FILES: "files",
  EMAIL: "email",
  ARRAY: "array",
  BOOLEAN: "boolean",
  DATE: "date",
  URL: "url",
  LOCATION: "location",
  TIME_RANGE: "time-range",
  SLIDER: "slider",
  TRANSLATABLE: "translatable",
  FACILITY_GROUP: "facility-group",
  NESTED_QUESTION: "nested-question",
  MULTISELECT_FILES: 'multi-select-files',
  TABLE: 'table'
};

export const AsanSignResponseCodes = {
  IN_PROGRESS: "in_progress",
  SUCCESS: "signature_created",
  SIM_ERROR: "sim_error",
  ERROR: "internal_error",
  CANCELLED: "user_canceled",
  EXPIRED_TRANSACTION: "expired_transaction",
};

export const GradeAppStatus = {
  ACCEPTED: "accepted",
  NEW: "new",
  // RENEWAL: "renewal",
  ONPROCESS: "onprocess",
  REJECTED: "rejected",
  // CLOSED: "closed",
  EDITED: "edited",
};

export const NotificationTypes = {
  Stakeholder: "stakeholder",
  GradeApplication: "gradeApplication",
  Training: "training",
  Event: "event",
};

export const NotificationStatus = {
  READ: "read",
  UNREAD: "unread",
};

export const countryCodes = [
  'AF',
  'AX',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'CV',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'CX',
  'CC',
  'CO',
  'KM',
  'CG',
  'CD',
  'CK',
  'CR',
  'CI',
  'HR',
  'CU',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'ET',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GM',
  'GE',
  'DE',
  'HK',
  'HU',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IL',
  'IT',
  'JM',
  'JP',
  'KZ',
  'KE',
  'KR',
  'KW',
  'KG',
  'LV',
  'LB',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MK',
  'MY',
  'MT',
  'MX',
  'MD',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'MM',
  'NP',
  'NL',
  'AN',
  'NC',
  'NZ',
  'NG',
  'NO',
  'OM',
  'PK',
  'PY',
  'PE',
  'PH',
  'PL',
  'PT',
  'QA',
  'RE',
  'RO',
  'RU',
  'SA',
  'RS',
  'SG',
  'SK',
  'SI',
  'SO',
  'ZA',
  'ES',
  'LK',
  'SD',
  'SZ',
  'SE',
  'CH',
  'SY',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UM',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'VG',
  'VI',
  'WF',
  'EH',
  'YE',
  'ZM',
  'ZW',
]

export const countries = {
  au: "/assets/images/flags/australia.svg",
  az: "/assets/images/flags/azerbaijan.svg",
  bh: "/assets/images/flags/bahrain.svg",
  bd: "/assets/images/flags/bangladesh.svg",
  by: "/assets/images/flags/belarus.svg",
  bg: "/assets/images/flags/bulgaria.svg",
  ca: "/assets/images/flags/canada.svg",
  cl: "/assets/images/flags/chile.svg",
  cn: "/assets/images/flags/china.svg",
  hr: "/assets/images/flags/croatia.svg",
  cz: "/assets/images/flags/czech-republic.svg",
  dk: "/assets/images/flags/denmark.svg",
  eg: "/assets/images/flags/egypt.svg",
  ee: "/assets/images/flags/estonia.svg",
  fi: "/assets/images/flags/finland.svg",
  fr: "/assets/images/flags/france.svg",
  ge: "/assets/images/flags/georgia.svg",
  de: "/assets/images/flags/germany.svg",
  gr: "/assets/images/flags/greece.svg",
  hu: "/assets/images/flags/hungary.svg",
  ic: "/assets/images/flags/iceland.svg",
  in: "/assets/images/flags/india.svg",
  id: "/assets/images/flags/indonesia.svg",
  iq: "/assets/images/flags/iraq.svg",
  ir: "/assets/images/flags/iran.svg",
  ie: "/assets/images/flags/ireland.svg",
  il: "/assets/images/flags/israel.svg",
  it: "/assets/images/flags/italy.svg",
  jp: "/assets/images/flags/japan.svg",
  kz: "/assets/images/flags/kazakhstan.svg",
  kw: "/assets/images/flags/kuwait.svg",
  kg: "/assets/images/flags/kyrgyzstan.svg",
  qa: "/assets/images/flags/qatar.svg",
  lv: "/assets/images/flags/latvia.svg",
  lb: "/assets/images/flags/lebanon.svg",
  ly: "/assets/images/flags/libya.svg",
  li: "/assets/images/flags/liechtenstein.svg",
  lu: "/assets/images/flags/luxembourg.svg",
  my: "/assets/images/flags/malaysia.svg",
  mx: "/assets/images/flags/mexico.svg",
  md: "/assets/images/flags/moldova.svg",
  me: "/assets/images/flags/montenegro.svg",
  ma: "/assets/images/flags/morocco.svg",
  nz: "/assets/images/flags/new-zealand.svg",
  ne: "/assets/images/flags/niger.svg",
  ng: "/assets/images/flags/nigeria.svg",
  no: "/assets/images/flags/norway.svg",
  om: "/assets/images/flags/oman.svg",
  pk: "/assets/images/flags/pakistan.svg",
  ps: "/assets/images/flags/palestine.svg",
  ph: "/assets/images/flags/philippines.svg",
  pl: "/assets/images/flags/poland.svg",
  pt: "/assets/images/flags/portugal.svg",
  mk: "/assets/images/flags/north-macedonia.svg",
  ro: "/assets/images/flags/romania.svg",
  ru: "/assets/images/flags/russia.svg",
  sa: "/assets/images/flags/saudi-arabia.svg",
  rs: "/assets/images/flags/serbia.svg",
  sg: "/assets/images/flags/singapore.svg",
  sk: "/assets/images/flags/slovakia.svg",
  si: "/assets/images/flags/slovenia.svg",
  za: "/assets/images/flags/south-africa.svg",
  kr: "/assets/images/flags/south-korea.svg",
  sp: "/assets/images/flags/spain.svg",
  lk: "/assets/images/flags/sri-lanka.svg",
  se: "/assets/images/flags/sweden.svg",
  ch: "/assets/images/flags/switzerland.svg",
  sy: "/assets/images/flags/syria.svg",
  tj: "/assets/images/flags/tajikistan.svg",
  th: "/assets/images/flags/thailand.svg",
  tr: "/assets/images/flags/turkey.svg",
  tm: "/assets/images/flags/turkmenistan.svg",
  gb: "/assets/images/flags/uk.svg",
  ua: "/assets/images/flags/ukraine.svg",
  ae: "/assets/images/flags/united-arab-emirates.svg",
  us: "/assets/images/flags/usa.svg",
  uz: "/assets/images/flags/uzbekistan.svg",
  vn: "/assets/images/flags/vietnam.svg",
  ye: "/assets/images/flags/yemen.svg",
};

export const facilityCapacities = [
  {
    value: "0-50",
  },
  {
    value: "50-250",
  },
  {
    value: "250-500",
  },
  {
    value: "500+",
  },
];

export const customStyles = {
  display: {
    display: "block",
    width: "200px",
  },
  flex: {
    display: "flex",
    flexWrap: "wrap",
  },
  margins: {
    marginBottom: "3%",
    marginRight: "8%",
  },
  marginBottomNegative: {
    marginBottom: "-6%",
  },
  textCenter: {
    textAlign: "center",
  },
  textTransform: {
    textTransform: "uppercase",
  },
};

export const gradeItems = [
  {
    _id: "id_a",
    degree: "A+",
    levelName: "key_grade_level_A",
    desc: [
      { value: "key_grade_A_option_1" },
      { value: "key_grade_A_option_2" },
      { value: "key_grade_A_option_3" },
      { value: "key_grade_A_option_4" },
      { value: "key_grade_A_option_5" },
    ],
  },
  {
    _id: "id_b",
    degree: "A",
    levelName: "key_grade_level_B",
    desc: [
      { value: "key_grade_B_option_1" },
      { value: "key_grade_B_option_2" },
      { value: "key_grade_B_option_3" },
      { value: "key_grade_B_option_4" },
      { value: "key_grade_B_option_5" },
    ],
  },
  {
    _id: "id_c",
    degree: "B",
    levelName: "key_grade_level_C",
    desc: [
      { value: "key_grade_C_option_1" },
      { value: "key_grade_C_option_2" },
      { value: "key_grade_C_option_3" },
      { value: "key_grade_C_option_4" },
    ],
  },
  {
    _id: "id_d",
    degree: "C",
    levelName: "key_grade_level_D",
    desc: [
      { value: "key_grade_D_option_1" },
      { value: "key_grade_D_option_2" },
      { value: "key_grade_D_option_3" },
      { value: "key_grade_D_option_4" },
      { value: "key_grade_D_option_5" },
    ],
  },
];

export const gradesData = {
  data: [
    {
      _id: "1",
      grade: "A+",
      acc: "acc1",
      desc: [
        "Onlayn platformalarda təbliğat (Azerbaijan.travel, meetinazerbaijan.com, tourismboard.az)",
        "Turizm mükafatlandırmaları"
      ]
    },
    {
      _id: "2",
      grade: "A",
      acc: "acc2",
      desc: [
        "Statistik təhlillərə əlçatanlıq",
        "Bazar araşdırmalarına əlçatanlıq"
      ]
    },
    {
      _id: "3",
      grade: "B",
      acc: "acc3",
      desc: [
        "Geniş statistik məlumatlara giriş",
        "Media kitabxanasına giriş"
      ]
    },
    {
      _id: "4",
      grade: "C",
      acc: "acc4",
      desc: [
        "Məhdud açıq statistik məlumatlara giriş",
        "Ödənişsiz onlayn təlimlərə giriş"
      ]
    },
  ],
};

export const eventTabTitle = [
  {
    key: "FUTURE_EVENTS",
    label: "key_upcoming_events",
    status: "Upcoming",
  },
  {
    key: "PAST_EVENTS",
    label: "key_past_events",
    status: "Past",
  },
  {
    key: "ATENDED_EVENTS",
    label: 'key_attended_events',
    status: "Atended",
  },
  {
    key: "HELPERS_EVENTS",
    label: "key_helpers_events",
    status: "Helpers",
  },
];

export const trainingTabTitle = [
  {
    key: "ALL_TRAINING",
    label: "key_all_trainings",
    status: undefined,
    key_node: ["Upcoming", "Current"],
  },
  {
    key: "PAST",
    label: "key_past_trainings",
    status: "Past",
    key_node: ["Past"],
  },
];

export const objects = [
  {
    objectCode: '111',
    name: "A obyekti",
    stateObject: {
      stakeholder_id: '',
      status: false
    }
  },
  {
    objectCode: '333',
    name: "C obyekti",
    stateObject: {
      stakeholder_id: '',
      status: false
    }
  },
  {
    objectCode: '222',
    name: "B obyekti",
    stateObject: {
      stakeholder_id: '',
      status: false
    }
  },
];

export const STEPS = {
  INDUSTRY_CHOICE: "INDUSTRY_CHOICE",
  QUESTIONARY: "QUESTIONARY",
  CRITERIA_QUESTIONS: "CRITERIA_QUESTIONS",
  STATIC_CRITERIA_QUESTIONS: "STATIC_CRITERIA_QUESTIONS",
  INSTITUTION_REGISTRY:"INSTITUTION_REGISTRY"
};

export const QUESTION_STEPS = {
  CLASSIFICATION_QUESTIONARY: "CLASSIFICATION_QUESTIONARY",
  CLASSIFICATION_QUESTIONARY_PREVIEW: "CLASSIFICATION_QUESTIONARY_PREVIEW",
};
